import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(2.6672 3.4704)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M11.1973 4C11.4897 4.29281 11.4897 4.76774 11.1973 5.06055L7.19727 9.06055L6.13672 8L8.85645 5.28027H0V3.78027H8.85645L6.13672 1.06055L7.19727 0L11.1973 4Z",
			fill: "currentColor"
		})
	})
});
export default SvgArrowRight;
